export default "__VITE_ASSET__CPzYOdSj__"